import { API_BASE } from './api';

const FORECAST_API = `${API_BASE}/forecast`;

export async function fetchSevenDayForecast() {
  const res = await fetch(`${FORECAST_API}/sevenday`, {
    method: 'GET',
    credentials: 'include',
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.message || 'Failed to load seven day forecast.');
  }

  return data;
}
